import actions from '@/store/emails/actions';

const adminModule = {
  state: () => ({
    emails: [],
    isLoading: false,
    error: null,
    preview: '',
    emailImage: null,
  }),
  mutations: {
    GET_EMAILS_START(state) {
      state.isLoading = true;
      state.error = null;
    },
    GET_EMAILS_SUCCESS(state, payload) {
      state.isLoading = false;
      state.emails = payload;
      state.error = null;
    },
    GET_EMAILS_FAILURE(state, payload) {
      state.isLoading = false;
      state.error = payload;
    },
    GET_EMAIL_PREVIEW_SUCCESS(state, payload) {
      state.preview = payload;
    },
    RESET_EMAIL_PREVIEW(state) {
      state.preview = '';
    },
    UPLOAD_EMAIL_IMAGE_SUCCESS(state, payload) {
      state.emailImage = payload;
    },
    CLEAR_EMAIL_IMAGE(state) {
      state.emailImage = null;
    },
  },
  actions,
  namespaced: true,
};

export default adminModule;
